// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"208":"a1d11fb6","578":"4aee1655"}[chunkId] + ".chunk.css";
};